import 'babel-polyfill';
import Vue from 'vue';
import App from './App';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/iconfont.css';
import './assets/less/app.less';

import store from './store'
import router from './router'
import i18n from './common/lang'
import http from './api'

import urlConfig from './api/urlConfig'

import './routerWatch'

Vue.use(ElementUI)

Vue.prototype.$urlConfig = urlConfig
Vue.prototype.$http = http

Vue.config.productionTip = false
/* eslint-disable no-new */

new Vue({
    el: '#app',
    router,
    store,
    i18n,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js